@if (isExporting) {
  <app-rings-loader> {{'Exporting data in progress...' | translate}}</app-rings-loader>
}
<div class="modal-title-div d-flex justify-content-between align-items-center py-2 px-4">
  <h4 class="modal-title card-title">
    {{'Export File' | translate}}
  </h4>
  <button type="button" class="close" (click)="cancel()"><span aria-hidden="true">×</span></button>
</div>
<mat-dialog-content>
  <div class="row mt-4">
    <div class="col-12">
      <div class="logo-date-head mt-2 mb-4 d-flex justify-content-between">
        <div class="company-logo">
          @if (logoUrl) {
            <img [src]="logoUrl" alt="Company Logo" class="tenant-logo">
          }
        </div>

        <span>{{'Report Date' | translate}}: {{currentDate}}</span>
      </div>
    </div>

    <div class="col-12">
      <div class="card-details text-center">
        <h4 class="card-title">{{'Risk Treatment' | translate}}</h4>
      </div>
    </div>

    <div class="col-12">
      <div class="table-section">
        <div class="table-responsive custom-theme-table custom-scrollbar">
          @if (dataSource.length) {
            <table mat-table class="table outer-bordered-table" [dataSource]="dataSource"
              >
              <ng-container matColumnDef="controlName">
                <th mat-header-cell *matHeaderCellDef>{{'Control Name' | translate}}</th>
                <td mat-cell class="bordered-cell" *matCellDef="let element">
                  {{element.controlName ?? '-' }}
                </td>
              </ng-container>
              <ng-container matColumnDef="controlBucketName">
                <th mat-header-cell *matHeaderCellDef>{{'Control Bucket Name' | translate}}</th>
                <td mat-cell class="bordered-cell" *matCellDef="let element">
                  {{element.controlBucketName ?? '-'}}
                </td>
              </ng-container>
              <ng-container matColumnDef="status">
                <th mat-header-cell *matHeaderCellDef>{{'Status' | translate}}</th>
                <td mat-cell class="bordered-cell" *matCellDef="let element">
                  {{element.status != null ? controlStatusEnum[element.status] : '-'}}
                </td>
              </ng-container>
              <ng-container matColumnDef="controlOwnerName">
                <th mat-header-cell *matHeaderCellDef>{{'Control Owner' | translate}}</th>
                <td mat-cell class="bordered-cell" *matCellDef="let element">
                  {{element.controlOwnerName ?? '-'}}
                </td>
              </ng-container>
              <ng-container matColumnDef="implementationStartDate">
                <th mat-header-cell *matHeaderCellDef>{{'Implementation Start Date' | translate}}</th>
                <td mat-cell class="bordered-cell" *matCellDef="let element">
                  {{element.implementationStartDate | dateFormat}}
                </td>
              </ng-container>
              <ng-container matColumnDef="implementationEndDate">
                <th mat-header-cell *matHeaderCellDef>{{'Implementation End Date' | translate}}</th>
                <td mat-cell class="bordered-cell" *matCellDef="let element">
                  {{element.implementationEndDate | dateFormat}}
                </td>
              </ng-container>
              <ng-container matColumnDef="targetImplementationStart">
                <th mat-header-cell *matHeaderCellDef>{{'Target Implementation Start Date' | translate}}</th>
                <td mat-cell class="bordered-cell" *matCellDef="let element">
                  {{element.targetImplementationStart | dateFormat}}
                </td>
              </ng-container>
              <ng-container matColumnDef="targetImplementationEnd">
                <th mat-header-cell *matHeaderCellDef>{{'Target Implementation End Date' | translate}}</th>
                <td mat-cell class="bordered-cell" *matCellDef="let element">
                  {{element.targetImplementationEnd | dateFormat}}
                </td>
              </ng-container>
              <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
              <tr mat-row *matRowDef="let row; let even = even; columns: displayedColumns;" class="even-row">
              </tr>
            </table>
          } @else {
            <div [innerHTML]=" noDataError">
            </div>
          }
        </div>
      </div>
    </div>
  </div>
</mat-dialog-content>

<mat-dialog-actions class="dialog-actions">
  <div class="d-flex flex-column w-100">
    <div class="btn-div">
      <a class="btn modal-footer-btn save-modal-btn w-50" (click)="save()">
      {{'Export report - PDF (Landscape)' | translate}}</a>
      <a class="btn modal-footer-btn save-modal-btn w-50" (click)="save('portrait')">
      {{'Export report - PDF (Portrait)' | translate}} </a>
    </div>
    <div class="mt-2">
      <a class="btn modal-footer-btn save-modal-btn w-100" (click)="exportToExcel()">
      {{'Export as Excel' | translate}}</a>
    </div>
  </div>
</mat-dialog-actions>